export default __webpack_public_path__ + "static/media/behance_rounded.771fe48a.svg";